import styled from 'styled-components';
import { motion } from 'framer-motion';

export const StyledFlippableCard = styled(motion.div)`
  position: absolute;
  width: 100%;
  height: 100%;
  .card-back {
    width: 100%;
    height: 100%;
  }
  .card-front {
    width: 100%;
    height: 100%;

    .card-front-text {
      position: absolute;
      width: 100%;
      bottom: 0;
      height: 25%;
      padding: 1px;

      .card-front-text-inner {
        color: #383838;
        font-family: comicSans;
        padding: 2% 5%;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #ebebeb;
        transform: rotateY(180deg);
        font-weight: bold;
        text-align: center;
      }
    }
  }
`;
